import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Noindex } from "../components/Noindex";

export default function NotFound() {
  const { t } = useLanguage();
  const nf = t.notFound;

  return (
    <main
      data-testid="not-found-page"
      className="bg-black min-h-screen flex items-center pt-28 pb-20"
    >
      <Noindex title={t.seo.notFound} />
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 w-full">
        <p className="overline mb-4">{nf.overline}</p>
        <h1 className="h-display text-yellow-400 text-7xl sm:text-8xl md:text-9xl">
          404
        </h1>
        <h2 className="h-display text-white text-3xl sm:text-4xl md:text-5xl mt-4 break-words">
          {nf.title}
        </h2>
        <p className="mt-6 text-white/60 max-w-lg leading-relaxed">{nf.body}</p>
        <div className="mt-10">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="cta-line inline-flex items-center gap-2 text-white text-xs font-bold uppercase tracking-[0.25em]"
          >
            {nf.cta}
            <ArrowUpRight className="btn-arrow w-4 h-4" />
          </Link>
        </div>
      </div>
    </main>
  );
}
